import { render } from "./Home.vue?vue&type=template&id=2e1439cb"
const script = {}
script.render = render

export default script